import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { BadBuyer } from '../bad-buyers/bad-buyers.component';
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';

import { BuyersGroup, BuyersGroupApiService } from '../buyers-groups-item/buyers-groups.service';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  selector: 'tc-bad-buyer-groups-dialog',
  styleUrls: ['./bad-buyer-groups-dialog.component.scss'],
  template: `
    <h2 mat-dialog-title class="buyer-group-title">
      Buyer Groups — {{ data.buyer.name }}
    </h2>
    
    <mat-dialog-content>
      @if (loading) {
        <div fxLayout="column" fxLayoutGap="8px">
          @for (_ of [1,2,3]; track _) {
            <div class="skeleton-loader thin-line"></div>
          }
        </div>
      }
    
      @if (!loading && !error && !groups.length) {
        <div class="placeholder text-center">
          <mat-icon>group_off</mat-icon>
          <p>No group found</p>
        </div>
      }
    
      @if (!loading && !error && groups.length) {
        <div class="groups-list">
          @for (group of groups; track group.group_id) {
            <div class="groups-list-item" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <span class="group-name">{{ group.name }}</span>
              <mat-icon>group</mat-icon>
            </div>
          }
        </div>
      }
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <button mat-button type="button" mat-dialog-close>Close</button>
    </mat-dialog-actions>
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogTitle, MatIcon, FlexLayoutModule],
})
export class BadBuyerGroupsDialogComponent extends OnDestroyMixin implements OnInit {
  data = inject<{
    buyer: BadBuyer;
}>(MAT_DIALOG_DATA)
  dialogRef = inject<MatDialogRef<BadBuyerGroupsDialogComponent>>(MatDialogRef)
  private buyersService = inject(BuyersGroupApiService)

  groups: BuyersGroup[] = [];
  loading = false;
  error = false;

  ngOnInit(): void {
    this.loading = true;
    this.buyersService.getBuyerGroups(this.data.buyer.account, Number.MAX_SAFE_INTEGER, 0).pipe(untilComponentDestroyed(this)).subscribe({
      next: (result) => {
        this.groups = result.data;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      },
    });
  }
}
